module.exports = __webpack_public_path__ + "img/poker-h13.76496b38.svg";